<template>
  <div class="otoCon">
    <template v-if="listData.length > 0">
      <div
        v-for="(item,index) in listData"
        :key="index"
        class="experienceList"
      >
        <div class="experienceListop">
          <div class="opopic">
            <img
              :src="item.broadcast_logo || errorImage"
              style="width: 100%;height: 100%;object-fit: contain;"
            />
          </div>
          <div class="opooinfo">
            <div class="opooinfoName">{{item.broadcast_name}}</div>
            <div class="opooinfosm">
              <ul>
                <li>{{item.exh_name}}</li>
                <li>{{item.periodTime}}</li>
              </ul>
            </div>
            <div class="opooinfobt">
              <ul>
                <!-- <li
                  class="opooinfobt_info_li"
                  style="width: 83px"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.location"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{item.location}}</div>
                  </el-tooltip>
                </li>
                <li
                  class="opooinfobt_info_li"
                  style="width: 181px"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.company"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{item.company}}</div>
                  </el-tooltip>
                </li>
                <li
                  class="opooinfobt_info_li"
                  style="width: 118px"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.user_post+'-'+item.truename"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{item.user_post}}-{{item.truename}}</div>
                  </el-tooltip>
                </li>
                <li
                  class="opooinfobt_info_li"
                  style="width: 83px"
                > -->
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.broadcast_class_name"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{item.broadcast_class_name}}</div>
                  </el-tooltip>
                                  </li>
                                  <li class="opooinfobt_info_li">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.broadcast_class_name"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{item.broadcast_type_name}}</div>
                  </el-tooltip>
                                  </li>
                                  <li
                  class="opooinfobt_info_li"
                  style="width: 190px;margin-right: 0"
                                  >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="language.contact+'：'+item.broadcast_contact"
                    placement="top-start"
                  >
                    <div class="opooinfobt_info_li">{{language.contact}}：{{item.broadcast_contact}}</div>
                  </el-tooltip>
                                  </li> -->
              </ul>
            </div>
          </div>
        </div>
        <!-- <div class="experienceListxt">{{item.broadcast_introduce}}</div> -->
        <div class="experienceLisBtn">
          <!-- <el-button type="primary" @click="showBroadcast(item,index)" style="background: #003f8f">
              <p v-if="item.broadcast_show == 1">
                <span v-if="lan == 'ch'">隐藏</span>
                <span v-else>HIDE</span>
              </p>
              <p v-if="item.broadcast_show == 0">
                <span v-if="lan == 'ch'">显示</span>
                <span v-else>SHOW</span>
              </p>
            </el-button> -->
          <!-- <el-button type="primary" @click="showImg(item)" v-if="lan == 'ch'" style="background: #003f8f">手机海报分享</el-button>-->
<!--            <el-button type="primary" @click="handleLineSee(item)" style="background: #003f8f">{{language.queue}}</el-button>-->
<!--            <el-button type="primary" @click="handleSee(item)" style="background: #003f8f">{{language.appointments}}</el-button>-->
<!--            <el-button type="primary" @click="showSetPanle(true,item)" style="background: #003f8f">{{language.appointment}}</el-button> -->
          <!--            <el-button type="primary" @click="handleSeeOfflineAppointments(item)" style="background: #003f8f">{{language.seeOfflineAppointments}}</el-button>-->
          <!-- <el-button type="primary" @click="editData(item.broadcast_id,item)" style="background: #003f8f">{{language.editExh}}</el-button> -->
          <el-button
            type="primary"
            @click="joinData(item.broadcast_id)"
            style="background: #ff9e00"
          >{{language.enterExh}}</el-button>
        </div>

        <div
          class="experienceLisBtn"
          v-if="item.exh_bstate == 3"
        ></div>
      </div>
    </template>
    <template v-else>
      <error-card :language="language" />
    </template>
    <!--查看预约弹窗-->
    <drag-dialog
      :show.sync="dialogShow"
      :title="title"
      :columns="columns"
      :language="language"
      :fn="stateEnum.SEEAPPOINTMENT"
      :init-cont="initCount"
      width="520px"
    />

    <!--查看线下预约弹窗-->
    <drag-dialog
      :show.sync="dialogOfflineAppointmentsShow"
      :title="title"
      :columns="columns"
      :language="language"
      :fn="stateEnum.OFFLINEAPPOINTMENTS"
      :init-cont="initCount"
      width="520px"
    />
    <!--查看排队弹窗-->
    <drag-dialog
      :show.sync="dialogLineUpShow"
      :title="title"
      :columns="columns"
      :language="language"
      :fn="stateEnum.LINEHISTORY"
      :init-cont="initCount"
      width="520px"
    />
    <!-- 预约时段设置 -->
    <appset
      :setName="setName"
      :exh_days_json="exh_days_json"
      :showSet="showSet"
      :broadcast_id="broadcast_id"
      :exhibition_id="exhibition_id"
      @toogleSet="toogleSet"
      :language="language"
    ></appset>
  </div>
</template>
<script>
import errorImage from "../../../../assets/error_room.png";
import errorCard from "../errorCard/index";
import dragDialog from "../../../../components/DragDialog/index";
import { stateEnum } from "../../attendancerecord/enum";
import appset from "../../appointments/set";
import Cookie from "../../../../common/cookie";
import { getPrevBrocastInfo } from "@/api/forum";
export default {
  components: {
    errorCard,
    dragDialog,
    appset,
  },
  props: {
    listData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    language: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      lan: Cookie.get("lang"),
      errorImage,
      stateEnum,
      showSet: false,
      exh_days_json: [],
      setName: "",
      dialogShow: false,
      dialogOfflineAppointmentsShow: false,
      title: "",
      broadcast_id: 0,
      exhibition_id: 0,
      initCount: null,
      columns: [
        {
          title: this.language.name,
          key: Cookie.get("lang") == "ch" ? "true_name" : "true_name_en",
          width: "105",
        },
        {
          title: this.language.hintContact,
          key: "tel",
          width: "130",
        },
        {
          title: this.language.companyName,
          key: Cookie.get("lang") == "ch" ? "company" : "company_en",
          width: "auto",
        },
        {
          title: this.language.subiectTime,
          key: "use_time",
          width: "auto",
        },
      ],
      dialogLineUpShow: false,
      LiveRoomLineList: [],
    };
  },
  mounted() {
    console.log(this.language.subiectTime);
  },
  methods: {
    toogleSet(d) {
      this.showSet = d;
    },
    showSetPanle(d, item) {
      this.showSet = d;
      this.setName = item.broadcast_name + "预约设置";
      this.exh_days_json = item.exh_days_json;
      this.broadcast_id = item.broadcast_id;
      this.exhibition_id = item.exhibition_id;
    },
    //1修改 2进入
    editData(id, item) {
      let param = {
        token: this.$store.state.user.token,
      };
      getPrevBrocastInfo(param).then((res) => {
        if (item.keyword != "") {
          this.$emit("changData", 1, id, item);
        } else {
          this.$emit("changData", 1, id, res.data);
        }
      });
    },
    joinData(id) {
      this.$emit("joinData", 2, id);
    },
    showImg(item) {
      this.$emit("showImg", item);
    },
    // 开启关闭直播间
    showBroadcast(item, index) {
      this.$emit("showBroadcast", item, index);
    },
    //查看预约
    handleSee(val) {
      this.title = this.language.watch + "-" + val.broadcast_name;
      this.initCount = val;
      this.dialogShow = true;
    },
    handleSeeOfflineAppointments(val) {
      this.title = this.language.watch + "-" + val.broadcast_name;
      this.initCount = val;
      this.dialogOfflineAppointmentsShow = true;
    },

    //查看排队历史
    handleLineSee(val) {
      this.title = this.language.watch + "-" + val.broadcast_name;
      this.initCount = val;
      this.dialogLineUpShow = true;
    },
    //查看联系方式
    // selectContact(item){
    //   this.$emit("selectContact", item)
    // }
  },
};
</script>
<style>
.experience .otoCon {
  min-height: 500px;
}
.experience .experienceList {
  width: 100%;
  background: #fff;
  margin-top: 10px;
  box-shadow: 0px 5px 6px rgba(205, 205, 205, 0.7);
  padding: 22px;
  box-sizing: border-box;
}
.experience .experienceList .experienceListop {
  display: flex;
}
.experience .experienceList .opopic {
  width: 130px;
  height: 130px;
}
.experience .experienceList .opopic img {
  width: 100%;
  height: 100%;
}
.experience .experienceList .opooinfo {
  margin-left: 21px;
}
.experience .experienceList .opooinfo .opooinfoName {
  font-size: 20px;
  color: #0f408a;
}
.experience .experienceList .opooinfo .opooinfosm,
.experience .experienceList .opooinfo .opooinfobt {
  margin: 20px 0;
  font-size: 14px;
  color: #424242;
}
.experience .experienceList .opooinfo .opooinfosm ul,
.experience .experienceList .opooinfo .opooinfobt ul {
  display: flex;
  align-items: center;
}
.experience .experienceList .opooinfo .opooinfosm ul li {
  margin-right: 40px;
}
.experience .experienceList .opooinfo .opooinfobt ul li {
  margin-right: 20px;
}
.experience .experienceList .experienceListxt {
  font-size: 14px;
  color: #a1a1a1;
  margin: 20px 0;
}
.experience .experienceList .experienceLisBtn {
  text-align: right;
}
.experience .experienceList .experienceLisBtn button {
  text-align: right;
  width: 100px;
  height: 40px;
  border-radius: 10px;
  border: none;
  padding: 0;
  font-size: 14px;
  text-align: center;
}
.experience .experienceList .experienceLisBtn button:nth-of-type(2) {
  background: #003f8f;
}
.experience .experienceList .experienceLisBtn button:nth-of-type(3) {
  background: #ff9e00;
}
.opooinfobt_info_li {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
